<template>
  <div class="aeration-view--container">
    <h1 class="aeration-view--h1">Your Lawn Needs to Breathe</h1>
    <h2 class="aeration-view--h2">
      This aeration package will loosen up your soil allowing water and minerals to reach the grass
      roots-creating a healthier lawn!
    </h2>
    <ul class="aeration-view--ul">
      <li class="aeration-view--li">
        Core aeration
        <LsIcon type="checkmark" class="aeration-view--checkmark " />
      </li>
      <li class="aeration-view--li">
        Make your watering go farther
        <LsIcon type="checkmark" class="aeration-view--checkmark " />
      </li>
      <li class="aeration-view--li">
        Soften your lawn
        <LsIcon type="checkmark" class="aeration-view--checkmark " />
      </li>
      <li class="aeration-view--li">
        Get a healthier &amp; fuller lawn
        <LsIcon type="checkmark" class="aeration-view--checkmark " />
      </li>
    </ul>
  </div>
</template>

<script>
import { LsIcon } from '@/components/common';

export default {
  name: 'AerationView',
  components: {
    LsIcon,
  },
};
</script>

<style lang="scss" scoped>
.aeration-view--h1 {
  font-weight: bold;
  margin-bottom: 9px;
}
.aeration-view--h2 {
  font-size: $size-4;
  margin-bottom: 20px;
}
.aeration-view--li {
  font-size: $size-5;
  font-weight: bold;
  padding: 15px 0px;
  display: flex;
  justify-content: space-between;
}
.aeration-view--li:not(:last-child) {
  border-bottom: 1px solid $primary-light;
}
.aeration-view--ul {
  margin-bottom: 20px;
}
</style>
